export const EmptyChatImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="238"
      height="122"
      viewBox="0 0 238 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg" // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <path
        d="M132.592 1H218.958C225.361 1 230.551 6.19027 230.551 12.5928V61.051L237.268 76.2239L218.372 61.051H132.592C126.189 61.051 120.999 55.8607 120.999 49.4582V31.0255V12.5928C121.002 6.19141 126.19 1.00274 132.592 1Z"
        fill="white"
        stroke="#A0A0A0"
        strokeLinecap="round"
      />
      <path d="M213 32H139H213Z" fill="#A0A0A0" />
      <path d="M213 32H139" stroke="#A0A0A0" />
      <path d="M213 18.5H139H213Z" fill="#A0A0A0" />
      <path d="M213 18.5H139" stroke="#A0A0A0" />
      <path d="M188 45.5H139H188Z" fill="#A0A0A0" />
      <path d="M188 45.5H139" stroke="#A0A0A0" />
      <path
        d="M85.4064 45.7761H19.0397C12.6372 45.7761 7.44689 50.9663 7.44689 57.3689V105.827L0.730469 121L19.626 105.827H85.4064C91.8089 105.827 96.9992 100.637 96.9992 94.2343V57.3689C96.9964 50.9675 91.8077 45.7788 85.4064 45.7761Z"
        fill="white"
        stroke="#A0A0A0"
        strokeLinecap="round"
      />
      <path d="M24.7988 76.6686H79.6423H24.7988Z" fill="#A0A0A0" />
      <path d="M24.7988 76.6686H79.6423" stroke="#A0A0A0" />
      <path d="M24.7988 63.2358H79.6423H24.7988Z" fill="#A0A0A0" />
      <path d="M24.7988 63.2358H79.6423" stroke="#A0A0A0" />
      <path d="M43.2676 90.1044H79.984H43.2676Z" fill="#A0A0A0" />
      <path d="M43.2676 90.1044H79.984" stroke="#A0A0A0" />
    </svg>
  )
}
